export type WithMirrordRoute<T> = T & { mirrord_route?: string };

/**
 * Returns a copy of the provided message with `mirrord_route` added when available.
 */
export function withMirrordRoute<T extends object>(
  message: T,
): WithMirrordRoute<T> {
  const mirrordRoute =
    typeof window !== 'undefined'
      ? (
          window as unknown as { getMirrordRoute?: () => string | null }
        ).getMirrordRoute?.() || undefined
      : undefined;

  return mirrordRoute
    ? ({
        ...message,
        mirrord_route: mirrordRoute,
      } as WithMirrordRoute<T>)
    : (message as WithMirrordRoute<T>);
}
